import type { FC } from 'react';
import { useId } from 'react';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import CopyIcon from '@wix/da-ds/pkg/Icons/16x16/Copy';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { useCopyToClipboard } from '@wix/da-shared-react/pkg/utils/hooks/useCopyToClipboard';

interface Props {
  value: string;
}

const ClientIdField: FC<Props> = ({ value }) => {
  const id = useId();
  const copyToClipboard = useCopyToClipboard(value);

  return (
    <TextInput
      id={id}
      label="client_id"
      value={value}
      postfix={
        <IconButton
          icon={CopyIcon}
          size="small"
          aria-labelledby={id}
          onClick={ev => {
            ev.preventDefault();
            copyToClipboard();
          }}
        />
      }
      noBottomSpacing
    />
  );
};
ClientIdField.displayName = 'ClientIdField';

export default ClientIdField;
